<template>
  <section id="searchBrand" ref="searchBrand">
    <GarageBrand :brand_name="brand" :brand_id="carBrandId" :color_kv="color"></GarageBrand>
    <div hidden>AUDI Pre-owned Cars</div>
  </section>
</template>

<script>
import GarageBrand from '../components/GarageBrand'

let vm = null
export default {
  metaInfo: {
    title: 'Audi Pre-owned Cars', // set a title
    meta: [{             // set meta
      name: 'keywords',
      content: 'Audi Pre-owned Cars'
    },
    {
      name: 'description',
      content: 'Audi Pre-owned Cars – Buy premium condition pre-owned cars with warranty.'
    }]
  },
  name: "AUDI",
  data() {
    return {
      metaData: 'Audi Pre-owned Cars',
      carBrandId: 20,
      brand: 'Audi',
      color: '#020203',
      favicon: '/favicon_Audi.ico'
    };
  },
  created() {
  },
  async mounted() {
    this.setFavicon()
  },
  beforeDestroy() {
    this.resetFavicon()
  },
  methods: {
    setFavicon() {
      let link = document.querySelector('link[rel="icon"]')
      if (link) {
        link.href = this.favicon
      }
    },
    resetFavicon() {
      let link = document.querySelector('link[rel="icon"]')
      if (link) {
        link.href = '/favicon.ico'
      }
    }
  },
  components: {
    GarageBrand
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/Audi.vue